import type { z } from "zod/v4";

export async function loadConfig<TSchema extends z.ZodObject<z.ZodRawShape>>(
  configPath: string,
  schema: TSchema
): Promise<z.infer<TSchema>> {
  const response = await fetch(configPath);
  if (!response.ok) {
    throw new Error("Failed to load config");
  }
  return schema.parse(await response.json());
}
